import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { AuthProvider } from './contexts/AuthContext.jsx';
import Login from './pages/auth/Login.jsx';
// import Register from './pages/auth/Register.jsx';
import Home from './pages/home/Home.jsx';
import Navbar from './components/layout/Navbar.jsx';
import Edgemarc from './pages/tabs/edgemarc/Edgemarc.jsx';
import Email from './pages/tabs/Email.jsx';
import Folder from './pages/tabs/Folder.jsx';
import Fax from './pages/tabs/Fax.jsx';
import Whois from './pages/tabs/Whois.jsx';
import Tabs from './pages/tabs/Tabs.jsx';
import Dispatch from './pages/tabs/Dispatch.jsx';
import FieldEngineer from './pages/tabs/FieldEngineer.jsx';
import Profile from './pages/auth/Profile.jsx';
import CreateTickets from './pages/tickets/CreateTickets.jsx';
import SearchComponent from './components/ui/SearchComponent.jsx';
import SearchResults from './pages/home/SearchResults.jsx';
import MyTickets from './pages/tickets/MyTickets.jsx';
import MyTicketsHump from './pages/tickets/MyTicketsHump.jsx';
import DashboardButtons from './components/ui/DashboardButtons.jsx';
import Customers from './pages/customers/Customers.jsx';
import AddCustomers from './pages/customers/AddCustomers.jsx';
import XrayLobby from './pages/tools/xray/XrayLobby/XrayLobby.js';
import Cidr from './pages/tools/cidr/Cidr.jsx';
import BicomTool from './pages/tools/bicom/BicomTool.jsx';
import ShowTickets from './pages/tickets/ShowTickets.jsx';
import ProtectedRoute from './components/layout/ProtectedRoute.jsx';

function Layout() {
  const location = useLocation();
  const hideNavbar = location.pathname === '/login';

  return (
    <>
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* <Route path="/register" element={<Register />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/email" element={<ProtectedRoute><Email /></ProtectedRoute>} />
        <Route path="/folder" element={<ProtectedRoute><Folder /></ProtectedRoute>} />
        <Route path="/edgemarc" element={<ProtectedRoute><Edgemarc /></ProtectedRoute>} />
        <Route path="/fax" element={<ProtectedRoute><Fax /></ProtectedRoute>} />
        <Route path="/whois" element={<ProtectedRoute><Whois /></ProtectedRoute>} />
        <Route path="/tabs/:id" element={<ProtectedRoute><Tabs /></ProtectedRoute>} />
        <Route path="/dispatch" element={<ProtectedRoute><Dispatch /></ProtectedRoute>} />
        <Route path="/fieldengineer" element={<ProtectedRoute><FieldEngineer /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/search" element={<ProtectedRoute><SearchComponent /></ProtectedRoute>} />
        <Route path="/search/search" element={<ProtectedRoute><SearchResults /></ProtectedRoute>} />
        <Route path="/shared-tickets" element={<ProtectedRoute><MyTickets /></ProtectedRoute>} />
        <Route path="/smart-ticket" element={<ProtectedRoute><MyTicketsHump /></ProtectedRoute>} />
        <Route path="/smart-ticket/:id" element={<ProtectedRoute><MyTicketsHump /></ProtectedRoute>} />
        <Route path="/dashboardButtons" element={<ProtectedRoute><DashboardButtons /></ProtectedRoute>} />
        <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
        <Route path="/addcustomers" element={<ProtectedRoute><AddCustomers /></ProtectedRoute>} />
        <Route path="/addcustomers/:id" element={<ProtectedRoute><AddCustomers /></ProtectedRoute>} />
        <Route path="/cidr" element={<ProtectedRoute><Cidr /></ProtectedRoute>} />
        <Route path="/bicom" element={<ProtectedRoute><BicomTool /></ProtectedRoute>} />
        <Route path="/smartTicket/:id" element={<ProtectedRoute><ShowTickets /></ProtectedRoute>} />
        <Route path="/createTickets" element={<ProtectedRoute><CreateTickets /></ProtectedRoute>} />
        <Route path="/xray" element={<ProtectedRoute><XrayLobby /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 3000,
            style: {
              background: '#333',
              color: '#000',
            },
          }}
        />
        <Layout />
      </AuthProvider>
    </Router>
  );
}

export default App;
